import React from "react";
import { Player } from 'video-react';
import "../../node_modules/video-react/dist/video-react.css"; // import css
import authAppVideo from '../assets/AuthApp.mp4'
import authAppVideoPoster from '../assets/AuthApp.PNG'

const AuthAppInstructions = () => {
  return (
    <div style={{textAlign:"left",padding:"20px"}}>
      <link rel="stylesheet" href="/css/video-react.css" />
      <h1> Auth App Setup Instructions. </h1>
      <div>Our Login Process supports a Time-based one-time password (TOTP) Authenticator Application.  
        You can use any TOTP application you have installed on your phone or computer.  If you do not have an authenticator app installed we recomend the plugins below.</div>
      <div style={{float:"right",width:"800px", height:"600px" ,padding:"20px"}}> 
        <Player
      playsInline
      poster={authAppVideoPoster}
      src={authAppVideo}
      />
    </div>
      <div style={{marginTop:"20px"}}>  <a target="_blank" rel='noreferrer' href="https://chrome.google.com/webstore/detail/authenticator/bhghoamapcdpbohphigoooaddinpkbai">Chrome</a>: A plugin for the Chrome browser</div>
      <div> <a target="_blank" rel='noreferrer' href="https://microsoftedge.microsoft.com/addons/detail/authenticator-2fa-client/ocglkepbibnalbgmbachknglpdipeoio?hl=en-US">Edge</a>: A plugin for the Edge browser</div>
      <h3>General Instructions</h3>
      <ol style={{marginTop:"20px"}} type = "1">
        <li>On the <a target="_blank" href="/login">Login</a> screen check the Manage MFA check box.</li>
        <li>Type your username / password and Sign In.</li>
        <li>Select the Instructions hyperlink on the Manage MFA dialogue box.</li>
        <li>To download the Authentication app, select the appropriate plug-in hyperlink for your browser to initiate the download</li>
        <li>After the appropriate plug-in link is selected, the Authentication App download page will appear.</li>
        <li>Click “Add Extension” when prompted.</li>
        <li>Once the Authentication App is downloaded, an extension confirmation notification will appear.</li>
        <li>On the "Manage MFA" dialog click the "Register App" button. The Dialog should change displaying a QR Code and a manual code. </li>
        <li>Open the Extension icon at the top right of the tool bar.</li>
        <li>Select the Authenticator option.</li>
        <li>In the top right corner of the Authenticator, select Copy QR Code.</li>
        <li>Using the cursor, drag and copy the QR Code to add Cognito to the Authenticator App.</li>
        <li>Select the Extension icon again and enter the numerical code into the MFA dialog box, then click the verify button.</li>
        <li>If it worked, you should see the Authenticator App Enabled. Click Save.</li>
        <li>Depending on your needs you can Enable the Authenticator App and/or SMS. If both are enabled, you will be prompted for what one to use when logging in.</li>
        <li>Click the Save Button to save your preferences and log into the application.</li>
      </ol>
      <h3>Backup and Recovery</h3>
      <div style={{marginTop:"20px"}}>
        If you lose access to Authenticator App you will need to contact Guardian to temporarily disable MFA on your account. This will let you log in and reset your Authenticator App following the instructions above.    
      </div>
    </div>
  );
};
  
export default AuthAppInstructions;